import React, { useEffect } from "react";

import { Col, Container, Button, Row } from "reactstrap";

import { connect } from "react-redux";
import { requestClass } from "../../../redux/actions/class_request_form";
import { fetchSubjectsByQualification } from "../../../redux/actions/api_subject";
import { createLoadingSelector } from "../../../redux/selectors";

import ImageJumbotron from "../../../components/ImageJumbotron";
import PackageCard from "../../../components/PackageCard";
import BottomBar from "../../../components/BottomBar";
import { Bell } from "react-feather";
import { getQualId } from "../../../helpers/qualificationIdentifier";

import Loader from "../../../components/Loader";

const IGCSE = ({
  fetchSubjectsByQualification,
  requestClass,
  history,
  isLoading,
  subjects,
}) => {
  useEffect(() => {
    const id = getQualId("igcse");
    fetchSubjectsByQualification(id);
  }, [fetchSubjectsByQualification]);

  const handleClick = () => {
    requestClass({ id: getQualId("igcse"), name: "IGCSE" });
    history.push("/page/class/request");
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <ImageJumbotron bg="banner4.jpg">
        <Container className="product_container">
          <Row>
            <Col md={6} sm={12}>
              <h1>IGCSE</h1>
              <h4>1:1 Online Class</h4>
              <p>
                IGCSE는 <span className="highlight">고등 과정 준비의 기초</span>
                가 되는 만큼 탄탄한 공부를 통해 고등 과정에 대한{" "}
                <span className="highlight">이해력을 높이는 것</span>이{" "}
                <span className="highlight">가장 중요합니다</span>.
              </p>
              <p>
                전반적으로 명문대학을 목표로 하는 학생들은 8 – 11개의 과목을
                수료하고, 이 과정은{" "}
                <span className="highlight">
                  A-Level을 공부하기 위한 기반이 됩니다
                </span>
                .
              </p>
              <p>
                저희 <span className="highlight">오버더문</span>에서는{" "}
                <span className="highlight">맞춤형 컨설팅</span>을 통해 학생의{" "}
                <span className="highlight">특성, 목표 대학교, 장래희망</span>
                등을 고려해서{" "}
                <span className="highlight">강사님을 매칭해드립니다.</span>
              </p>
              <p>
                해외 곳곳에 위치한{" "}
                <span className="highlight">명문대 출신</span> 강사님들을 통해
                <span className="highlight"> 1:1 맞춤형</span> 온라인 강의를
                받아보세요.
              </p>
            </Col>
            <Col md={6} sm={12}>
              <PackageCard
                subjects={subjects}
                qualification="IGCSE"
                classMethod="비대면"
                targetAudience="중학생 (2,3학년)"
                onClick={handleClick}
              />
            </Col>
          </Row>
        </Container>
      </ImageJumbotron>
      <BottomBar>
        <Row>
          <Col md={8} sm={12}>
            <div className="d-inline-block">
              <Bell style={{ position: "relative", bottom: "10" }} />
            </div>
            <div className="d-inline-block pl-2">
              <p style={{ fontWeight: "700" }}>
                EARLY BIRD <span style={{ fontWeight: "900" }}>20%</span> 특별
                할인 이벤트!
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                8월 24일 전에 신청하시면 할인 혜택을 받으실수 있습니다.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <Button
              color="danger"
              style={{ width: "100%" }}
              onClick={handleClick}
            >
              수강 신청하기
            </Button>
          </Col>
        </Row>
      </BottomBar>
      <div className="site-section mt-0 pt-4">
        <Container className="class-page">
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>IGCSE 커리큘럼</h2>
                <hr />
              </div>
              <div className="col-md-6">
                <p>
                  GCSE란 International General Certificate of Secondary
                  Education의 약자로 영국의 중등 과정으로서, 영국식 고등 과정인
                  A-Level을 공부하기 위해 필요한 시험입니다. IGCSE는 국제 학생을
                  위해 GCSE를 International Curriculum으로 개조 한 것이며, 시험
                  보드에 따라 Cambridge IGCSE 또는 Edexcel IGCSE의 시험을
                  봅니다.
                </p>
              </div>
              <div className="col-md-3 text-center">
                <img
                  src={require("../../../assets/img/IGCSE_edexcel_logo.jpg")}
                  className="img-fluid"
                  alt=" "
                />
              </div>
              <div className="col-md-3 text-center">
                <img
                  src={require("../../../assets/img/IGCSE_cie_logo.jpg")}
                  className="img-fluid"
                  alt=" "
                />
              </div>
            </div>
          </div>
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>과목 선정 및 조합</h2>
                <hr />
              </div>
              <div className="col-md-12 text-center">
                <img
                  src={require("../../../assets/img/IGCSE_subjects.png")}
                  className="img-fluid"
                  alt="alevel_subjects"
                />
              </div>
            </div>
          </div>
          <div className="sub-section">
            <h2>오버더문 수업 진행 절차</h2>
            <hr />
            <p className="text-center">
              <img
                src={require("../../../assets/img/IGCSE_process.png")}
                className="img-fluid"
                alt=" "
              />
            </p>
          </div>
          <div className="sub-section">
            <div className="row">
              <div className="col-md-12">
                <h2>성적평가와 대학 진학</h2>
                <hr />
              </div>
              <div className="col-md-12">
                <p>
                  각 Subject Area 과목들은 7점이 만점으로 평가되고 있으며 선택한
                  6 과목을 통해 최대 42점을 받을 수 있고 부과목인 TOK, CAS, EE
                  등의 추가 이수 요건들을 통해 추가 3점을 더 받아 IB의 최고점인
                  45점을 받을 수 있습니다.
                </p>
                <p className="text-center">
                  <img
                    src={require("../../../assets/img/IGCSE_grades.png")}
                    className="img-fluid"
                    alt=" "
                  />
                </p>
              </div>
            </div>
          </div>
          <div className="sub-section">
            <h2>상담 문의</h2>
            <hr />
            <p className="text-center">
              <a
                href="https://pf.kakao.com/_xdNrsT"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../../../assets/img/kakaoplus.png")}
                  className="img-fluid"
                  alt="kakaoplus"
                />
              </a>
            </p>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

const loadingSelector = createLoadingSelector(["FETCH_SUBJECTS"]);

const mapStateToProps = (state) => ({
  isLoading: loadingSelector(state),
  subjects: state.api_subject.subjects,
});

const mapDispatchToProps = (dispatch) => ({
  requestClass: (class_type) => dispatch(requestClass(class_type)),
  fetchSubjectsByQualification: (qualification) =>
    dispatch(fetchSubjectsByQualification(qualification)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IGCSE);
